module.exports = __webpack_public_path__ + "img/001-invoice.31bc42a8.svg";